export const environment = {
  name: 'prod',
};
